export enum Units {
  Feet = 'Feet',
  Metres = 'Metres',
}
